import { render, staticRenderFns } from "./RelatorioResumoComercial.vue?vue&type=template&id=facf7be6&scoped=true"
import script from "./RelatorioResumoComercial.vue?vue&type=script&lang=js"
export * from "./RelatorioResumoComercial.vue?vue&type=script&lang=js"
import style0 from "./RelatorioResumoComercial.vue?vue&type=style&index=0&id=facf7be6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facf7be6",
  null
  
)

export default component.exports